import { useDocumentTitle } from "hooks/useDocumentTitle";
import {
  useDocumentMeta,
  DEFAULT_SEO_TITLE,
} from "hooks/useDocumentMeta";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PathName } from "routers/types";
import { useData } from "data/data-provider";
import Header from "../components/Header/Header";

export type SiteHeaders = "Header 1" | "Header 2" | "Header 3";

let OPTIONS = {
  root: null,
  rootMargin: "0px",
  threshold: 1.0,
};
let OBSERVER: IntersectionObserver | null = null;
const PAGES_HIDE_HEADER_BORDER: PathName[] = ["/home", "/listing-car-detail"];

const SiteHeader = () => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [isTopOfPage, setIsTopOfPage] = React.useState(window.pageYOffset < 5);
  const location = useLocation();
  const { companyDetails } = useData();

  const intersectionCallback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
      setIsTopOfPage(entry.isIntersecting);
    });
  };

  useEffect(() => {
    // disconnect the observer
    if (!PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)) {
      OBSERVER && OBSERVER.disconnect();
      OBSERVER = null;
      return;
    }
    if (!OBSERVER) {
      OBSERVER = new IntersectionObserver(intersectionCallback, OPTIONS);
      anchorRef.current && OBSERVER.observe(anchorRef.current);
    }
  }, [location.pathname]);

  let headerClassName = "shadow-sm dark:border-b dark:border-neutral-700";
  if (PAGES_HIDE_HEADER_BORDER.includes(location.pathname as PathName)) {
    headerClassName = isTopOfPage
      ? ""
      : "shadow-sm dark:border-b dark:border-neutral-700";
  }
  // The account's own SEO title from the 1Now API, falling back to the
  // shared default only once the payload has landed — passing it earlier
  // would flash a title over the one index.html already carries.
  useDocumentTitle(
    companyDetails ? companyDetails.seo_title || DEFAULT_SEO_TITLE : undefined,
  );
  // 1NOW-1645 — description, social-share and canonical tags, from the same
  // tenant payload. The header renders on every page, so this covers the site.
  useDocumentMeta(companyDetails);
  return (
    <>
      <Header className={headerClassName} navType="MainNav1" />
      <div ref={anchorRef} className="h-1 absolute invisible"></div>
    </>
  );
};

export default SiteHeader;
